import { render, staticRenderFns } from "./mscService.vue?vue&type=template&id=4b9e067d&"
import script from "./mscService.vue?vue&type=script&lang=js&"
export * from "./mscService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9e067d')) {
      api.createRecord('4b9e067d', component.options)
    } else {
      api.reload('4b9e067d', component.options)
    }
    module.hot.accept("./mscService.vue?vue&type=template&id=4b9e067d&", function () {
      api.rerender('4b9e067d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/mscService.vue"
export default component.exports